// src/services/interactionService.js
import axios from 'axios'
import { API_BASE_VISUALIZER, API_INTERACTIONS } from '../../../helpers/urlHelper'

const api = axios.create({
  baseURL: API_BASE_VISUALIZER
});

console.log('🔧 Axios baseURL =', api.defaults.baseURL);
export function fetchInteractions() {
  return api
    .get(API_INTERACTIONS)
    .then(res => res.data)
    .catch(err => {
      // Puedes afinar este mensaje según tu UI
      throw new Error(
        `Error fetching interactions: ${err.response?.status || err.message}`
      )
    })
}
